import React from 'react';

export function EmailListSkeleton() {
  return <div role="status" aria-label="Loading emails">
    <span className="sr-only">Loading emails…</span>
    <div aria-hidden="true" className="divide-y divide-gray-100 motion-safe:animate-pulse">
      {[0, 1, 2, 3, 4, 5].map(row => <div key={row} className="flex items-center gap-3 p-4">
        <div className="h-10 w-10 shrink-0 rounded-full bg-gray-100" />
        <div className="min-w-0 flex-1 space-y-2.5">
          <div className="flex items-center justify-between gap-4"><div className={`h-3 rounded bg-gray-200 ${row % 2 ? 'w-1/2' : 'w-2/3'}`} /><div className="h-2 w-7 rounded bg-gray-100" /></div>
          <div className={`h-3 rounded bg-gray-100 ${row % 2 ? 'w-5/6' : 'w-3/4'}`} />
        </div>
      </div>)}
    </div>
  </div>;
}

export default function EmailInboxLoading({ conversation = false }) {
  return <div className="email-inbox-frame flex h-full min-h-0 overflow-hidden rounded-xl border border-gray-200 bg-white" aria-busy="true">
    <div className={`${conversation ? 'hidden lg:block' : ''} w-full overflow-hidden border-r border-gray-200 lg:w-80 lg:shrink-0`}>
      <div aria-hidden="true" className="motion-safe:animate-pulse">
        <div className="flex min-h-[68px] items-center justify-between gap-3 border-b border-gray-200 px-4"><div className="h-3 w-28 rounded bg-gray-200" /><div className="h-10 w-24 rounded-lg bg-gray-100" /></div>
        <div className="flex min-h-[69px] items-center border-b border-gray-200 px-4"><div className="h-3 w-24 rounded bg-gray-200" /></div>
      </div>
      <EmailListSkeleton />
    </div>
    <div className={`${conversation ? 'block' : 'hidden lg:flex'} min-w-0 flex-1 bg-gray-50/50`}>
      {conversation ? <div role="status" className="w-full"><span className="sr-only">Loading email conversation…</span><div aria-hidden="true" className="motion-safe:animate-pulse">
        <div className="flex h-[61px] items-center gap-4 border-b bg-white px-4"><div className="h-6 w-6 rounded bg-gray-100" /><div className="h-3 w-1/2 rounded bg-gray-200" /></div>
        <div className="m-4 space-y-5 rounded-xl border border-gray-200 bg-white p-5"><div className="flex items-center gap-3"><div className="h-9 w-9 rounded-full bg-gray-100" /><div className="h-3 w-32 rounded bg-gray-200" /></div><div className="space-y-3 border-t pt-5">{[0, 1, 2, 3].map(line => <div key={line} className={`h-3 rounded bg-gray-100 ${line === 3 ? 'w-2/3' : 'w-full'}`} />)}</div></div>
      </div></div> : <div aria-hidden="true" className="m-auto flex h-16 w-16 items-center justify-center rounded-2xl border border-gray-200 bg-white"><div className="h-6 w-8 rounded bg-gray-100 motion-safe:animate-pulse" /></div>}
    </div>
  </div>;
}
